var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isUndergraduateCourse)?_c('DropDownMenuOption',{attrs:{"action":_vm.goToLink}},[_c('Icon',{staticClass:"dropdown-bottom__icon",attrs:{"name":"listAlt"}}),_vm._v(" "+_vm._s(_vm.$t('customDropdownMenu.finalAssessments'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }